import { render, staticRenderFns } from "./RoleListSelect.vue?vue&type=template&id=66c79f5b&scoped=true"
import script from "./RoleListSelect.vue?vue&type=script&lang=js"
export * from "./RoleListSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c79f5b",
  null
  
)

export default component.exports